import { render, staticRenderFns } from "./GameSettings.vue?vue&type=template&id=5d87744c&scoped=true"
import script from "./GameSettings.vue?vue&type=script&lang=js"
export * from "./GameSettings.vue?vue&type=script&lang=js"
import style0 from "./GameSettings.vue?vue&type=style&index=0&id=5d87744c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d87744c",
  null
  
)

export default component.exports